import {
  MATCHING_GROUND_ACTIVE_BG,
  MATCHING_GROUND_ACTIVE_TEXT,
  MATCHING_GROUND_MATCHING_BG,
  MATCHING_GROUND_MATCHING_TEXT,
  MATCHING_GROUND_UPCOMING_BG,
  MATCHING_GROUND_UPCOMING_TEXT,
  MATCHING_GROUND_CLOSED_BG,
  MATCHING_GROUND_CLOSED_TEXT,
  MATCHING_GROUND_ARCHIVED_BG,
  MATCHING_GROUND_ARCHIVED_TEXT
} from "../../constants/styles";
import { MatchingRoundColors } from "./types";


export const MATCHING_ROUND_COLORS: MatchingRoundColors = {
  "UPCOMING": {bg: MATCHING_GROUND_UPCOMING_BG, text: MATCHING_GROUND_UPCOMING_TEXT},
  "ACTIVE": {bg: MATCHING_GROUND_ACTIVE_BG, text: MATCHING_GROUND_ACTIVE_TEXT},
  "MATCHING": {bg: MATCHING_GROUND_MATCHING_BG, text: MATCHING_GROUND_MATCHING_TEXT},
  "ARCHIVED": {bg: MATCHING_GROUND_ARCHIVED_BG, text: MATCHING_GROUND_ARCHIVED_TEXT},
  "CLOSED": {bg: MATCHING_GROUND_CLOSED_BG, text: MATCHING_GROUND_CLOSED_TEXT},
};
  